module.exports = __webpack_public_path__ + "static/media/full-page-log-header.f4e4be23.png";